<template>
  <div class="contradiction">
    <span>巨大的市场前景与行业壁垒之间的矛盾</span>
    <span>是制约行业中小微企业“沉浸”行业的主要矛盾</span>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
};
</script>

<style lang="less" scoped>
.contradiction {
  height: 240px;
  background-image: url('@/assets/img/cooperation/Contradiction/background.png');
  background-position: center;
  background-size: cover;
  line-height: 56px;
  font-family: @font-bold;
  font-size: 28px;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
